import isAuthenticated from "../../../components/Utils/isAuthenticated";
import { getViewCatalog } from "../../../components/Api/Getters";
import React, { useState, useEffect, useRef } from "react";
import {
	TextField,
	List,
	ListItem,
	ListItemText,
	Box,
	Typography,
	CircularProgress,
	Button,
	Stack,
} from "@mui/material";

export default function ViewCatalog() {
	const [items, setItems] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchText, setSearchText] = useState("");
	const [matchIndexes, setMatchIndexes] = useState([]);
	const [currentMatchIndex, setCurrentMatchIndex] = useState(0);

	const itemRefs = useRef({});

	const auth = isAuthenticated();
	const token = auth.token;

	useEffect(() => {
		async function fetchItems() {
			if (token) {
				setLoading(true);
				const data = await getViewCatalog(token);
				//console.log("Fetched items:", data);
				//if (data.length > 0) {
				//   console.log("First item:", data[0]);
				//}
				setItems(data);
				setLoading(false);
			}
		}
		fetchItems();
	}, [token]);

	// Update matches when searchText or items change
	useEffect(() => {
		const matches = [];
		if (searchText.trim().length > 2) {
			const lowerSearch = searchText.toLowerCase();
			items.forEach((item, idx) => {
				if (item.text.toLowerCase().includes(lowerSearch)) {
					matches.push(idx);
				}
			});
		}
		setMatchIndexes(matches);
		setCurrentMatchIndex(0);
	}, [searchText, items]);

	// Scroll to current match
	useEffect(() => {
		if (matchIndexes.length > 0) {
			const item = items[matchIndexes[currentMatchIndex]];
			if (item && itemRefs.current[item.itemno]) {
				itemRefs.current[item.itemno].scrollIntoView({
					behavior: "smooth",
					block: "center",
				});
			}
		}
	}, [currentMatchIndex, matchIndexes, items]);

	const handleNext = () => {
		if (matchIndexes.length > 0) {
			setCurrentMatchIndex((prev) => (prev + 1) % matchIndexes.length);
		}
	};

	const handlePrevious = () => {
		if (matchIndexes.length > 0) {
			setCurrentMatchIndex((prev) => (prev - 1 + matchIndexes.length) % matchIndexes.length);
		}
	};

	// Highlight match in text
	const highlightMatch = (text) => {
		if (!searchText.trim()) return text;

		const regex = new RegExp(`(${searchText})`, "ig");
		const parts = text.split(regex);

		return parts.map((part, i) =>
			regex.test(part) ? (
				<span key={i} style={{ backgroundColor: "#ffff00" }}>
					{part}
				</span>
			) : (
				part
			),
		);
	};

	return (
		<div className="w-full  pt-4 min-h-[70dvh] bg-digitalWhite">
			<div className="max-w-4xl mx-auto bg-white rounded p-4 shadow">
				<Typography variant="h6" gutterBottom>
					Question Catalog List
				</Typography>

				<TextField
					label="Search Questions"
					variant="outlined"
					fullWidth
					margin="normal"
					value={searchText}
					onChange={(e) => setSearchText(e.target.value)}
				/>

				{matchIndexes.length > 0 && (
					<Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
						<Button size="small" onClick={handlePrevious} variant="outlined">
							Previous
						</Button>
						<Button size="small" onClick={handleNext} variant="outlined">
							Next
						</Button>
						<Typography variant="body2">
							Match {currentMatchIndex + 1} of {matchIndexes.length}
						</Typography>
					</Stack>
				)}

				<Box
					sx={{
						maxHeight: 400,
						overflowY: "auto",
						border: "1px solid #ccc",
						borderRadius: 2,
						p: 1,
						bgcolor: "#fafafa",
					}}
				>
					{loading ? (
						<CircularProgress />
					) : (
						<List dense>
							{items.length === 0 ? (
								<Typography variant="body2" sx={{ m: 1 }}>
									No items found.
								</Typography>
							) : (
								items.map((item, idx) => (
									<ListItem
										key={item.itemno}
										divider
										ref={(el) => (itemRefs.current[item.itemno] = el)}
									>
										<ListItemText
											primary={`Item #${item.itemno}
										          - ${
																item.itmtyp === "OPEN"
																	? "Open Question"
																	: item.itmtyp === "RATE"
																		? "Rating Question"
																		: ""
															}`}
											secondary={highlightMatch(item.text)}
										/>
									</ListItem>
								))
							)}
						</List>
					)}
				</Box>
			</div>
		</div>
	);
}
